import Vue from "vue";
import List from "./views/List/List.vue";
import Vuetify from "vuetify/lib";
import appStore from "./store/appStore";
import de from "vuetify/es5/locale/de";
import en from "vuetify/es5/locale/en";
import createRouter from "@/router";
import { getURLParamsObject } from "@/helpers/commonHelper";

Vue.config.productionTip = false;
Vue.use(Vuetify);

// loading wrapper for each instance
const $elements = document.getElementsByClassName("eoev-app-widget");
const savedElements = []; // save elements to array, since array will otherwise be reduce while looping
for (let i = 0; i < $elements.length; i++) {
  savedElements.push($elements[i]);
}

const colorConfig = getURLParamsObject(true);

for (let i = 0; i < savedElements.length; i++) {
  const $el = savedElements[i];

  const locale =
    ($el.attributes["data-locale"] && $el.attributes["data-locale"].value) ||
    "de-de";

  const getColor = (key, defaultValue) =>
    $el.attributes[`data-${key}`]?.value || colorConfig?.[key] || defaultValue;

  // build vuetify instance using certain colors
  const opts = {
    icons: {
      iconfont: "mdiSvg"
    },
    theme: {
      options: {
        customProperties: true
      },
      themes: {
        light: {
          primary: getColor("color-primary", "#97bd0f"),
          secondary: getColor("color-secondary", "#5d7114"),
          accent: getColor("color-accent", "#2468c9"),
          error: getColor("color-error", "#c55c52"),
          info: getColor("color-info", "#314d57"),
          success: getColor("color-success", "#97bd0f"),
          warning: getColor("color-warning", "#e2d7af")
        }
      }
    },
    lang: {
      locales: { de, en },
      current: locale
    }
  };
  const vuetify = new Vuetify(opts);

  // do we have initial data?
  const data = $el.querySelector(".eoev-app-widget-initial-data");
  const settings = $el.querySelector(".eoev-app-widget-settings");

  // set as constants to avoid overwriting of settings below
  const id = $el.attributes.id && $el.attributes.id.value;
  const initialNextPage =
    ($el.attributes["data-next-page"] &&
      $el.attributes["data-next-page"].value) ||
    -1;
  const namespace =
    ($el.attributes["data-namespace"] &&
      $el.attributes["data-namespace"].value) ||
    "eoev";
  const mapAbove = parseInt(
    $el.attributes["data-map-above"] && $el.attributes["data-map-above"].value
  );
  const mapBelow = parseInt(
    $el.attributes["data-map-below"] && $el.attributes["data-map-below"].value
  );

  // create store
  const store = appStore(namespace, {
    targetUri:
      $el.attributes["data-target-uri"] &&
      $el.attributes["data-target-uri"].value,
    apiUrl:
      $el.attributes["data-api-url"] && $el.attributes["data-api-url"].value,
    apiKey:
      $el.attributes["data-api-key"] && $el.attributes["data-api-key"].value,
    firstDayOfWeek:
      ($el.attributes["data-first-day-of-week"] &&
        $el.attributes["data-first-day-of-week"].value) ||
      1,
    textColor: getColor("color-text", "#333"),
    mapPinFillColor: getColor("map-pin-fill-color", "#257eca"),
    mapPinStrokeColor: getColor("map-pin-stroke-color", "#2d5069"),
    mapPinFillColorActive: getColor("map-pin-fill-color-active", "#c55c52"),
    mapPinStrokeColorActive: getColor("map-pin-stroke-color-active", "#5d332f"),
    mapAbove: isNaN(mapAbove) ? 0 : mapAbove,
    mapBelow: isNaN(mapBelow) ? 0 : mapBelow
  });

  const highlight = parseInt(
    $el.attributes["data-highlight"] && $el.attributes["data-highlight"].value
  );

  // create router
  const router = createRouter({
    ...settings,
    highlight
  });

  new Vue({
    vuetify,
    store,
    router,
    render: function(h) {
      return h(List, {
        props: {
          id: id,
          "initial-data": (data && JSON.parse(data.innerHTML)) || undefined,
          "initial-settings":
            (settings && JSON.parse(settings.innerHTML)) || undefined,
          "initial-next-page": initialNextPage
        }
      });
    }
  }).$mount($el);
}
